(function() {
    'use strict';

    angular
        .module('app.controllers.systemSettingsLocation', ['vsGoogleAutocomplete'])
        .factory('googleMapsLoader', function($q, frontEndSettingsService) {
            'ngInject';
            
            return {
                load: function() {
                    var deferred = $q.defer();

                    let possibleLibrary = document.getElementById('GoogleMapsLibrary');
                    if (possibleLibrary !== null) {
                        deferred.resolve('Google Maps Library already loaded');
                    } else {
                        window.handleClientLoad = function() {
                            deferred.resolve('Google Maps Library loaded');
                        };

                        frontEndSettingsService.getFrontendSettings()
                            .then(function(settings) {
                                /* Based on AngularJS - load google map script async in directive for multiple maps.
                                   See https://stackoverflow.com/a/24246967. */
                                console.log('Loading Google Maps Library with language: "' + settings.LanguageCode + '"');
                                // use global document since Angular's $document is weak
                                var script = document.createElement('script');
                                script.setAttribute("id", "GoogleMapsLibrary");
                                script.setAttribute("async", "");
                                script.setAttribute("defer", "");
                                script.type = 'text/javascript';
                                script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAx0hH0GNm24a5IaEvFd6bYh778Ll4nskw&callback=handleClientLoad&libraries=places&language=' + settings.LanguageCode;

                                document.body.appendChild(script);
                            });
                    }

                    return deferred.promise;
                }
            };
        })
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('system.settings.location', {
                    abstract: true,
                    url: '/location',
                    template: '<ui-view></ui-view>',
                    breadcrumb: {
                        ignore: true
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('system.settings.location.default', {
                    url: '/:menuEntryId',
                    defaultParams: {menuEntryId: '00000000-0000-0000-0000-000000000000'},
                    templateUrl: 'views/CustomActions/systemSettingsLocation.html',
                    controller: 'SystemSettingsLocationCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: function () {
                            return 'NAV_SystemSettingsLocation';
                        }
                    },
                    resolve: {
                        astroMenuValues: ["API", "xCenterConfig", function (API, xCenterConfig) {
                            const dataPoints = [
                                { 'DeviceId': xCenterConfig.var.guid_Empty, 'DatapointConfigId': xCenterConfig.datapointsDateTime.Place },
                                { 'DeviceId': xCenterConfig.var.guid_Empty, 'DatapointConfigId': xCenterConfig.datapointsDateTime.Longitude },
                                { 'DeviceId': xCenterConfig.var.guid_Empty, 'DatapointConfigId': xCenterConfig.datapointsDateTime.Latitude },
                                { 'DeviceId': xCenterConfig.var.guid_Empty, 'DatapointConfigId': xCenterConfig.datapointsDateTime.Sunrise },
                                { 'DeviceId': xCenterConfig.var.guid_Empty, 'DatapointConfigId': xCenterConfig.datapointsDateTime.Sunset }
                            ];

                            const api = new API();
                            const readValuesParams = { "DatapointValues": dataPoints, IgnoreErrors: false };
                            return api.Datapoint.ReadValues(readValuesParams).$promise
                            .then(function (data) {
                                let astroObj = {
                                    place: '',
                                    longitude: '',
                                    latitude: ''
                                };

                                if (data) {
                                    astroObj.place = data[0].Value;
                                    astroObj.longitude = data[1].Value;
                                    astroObj.latitude = data[2].Value;
                                    astroObj.sunrise = moment(data[3].Value);
                                    astroObj.sunset = moment(data[4].Value);
                                }

                                return astroObj;
                            });

                        }]
                    }
                });
        }])
        .controller('SystemSettingsLocationCtrl', SystemSettingsLocationCtrl)
        ;

        /* @ngInject */
        function SystemSettingsLocationCtrl(
            __MenuEntry,
            $translate,
            viewMenuBarService,
            appConfig,

            API,
            astroMenuValues,
            googleMapsLoader,

            $timeout,
            $scope,
            xCenterConfig,
            $log
        ) {
            var vm = this;

            var favoriteObject = {
                favoriteType: 'MenuEntry',
                favoriteObject: __MenuEntry.$buildRaw({
                    "MenuEntryId": '0a58fc5a-5afb-4d27-b3ee-4285a53d8004',
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "DeviceId": '00000000-0000-0000-0000-000000000000',
                    'CustomActionName': 'Location',
                    'DisplayName': $translate.instant('NAV_SystemSettingsLocation'),
                    'ImageName': 'netzwerk',
                    'CustomActionDatas': {},
                    $UI: {}
                })
            };
            viewMenuBarService.setFavorite(favoriteObject);

            var shouldUseGoogleApi = () => {
                if (appConfig().isLocal) {
                    console.debug('Local connection used, disabling Google API');
                    return false;
                }
                return true;
            }

            this.$onInit = function() {
                /* Show only cities in autocomplete field. */
                vm.autocompleteOptions = {
                  types: ['(cities)']
                };

                vm.useGoogleInput = shouldUseGoogleApi();
                vm.firstLoad = true;
                vm.address = {};
                vm.astroMenuValues = astroMenuValues;

                /* old- properties contain original value used when cancelling button */
                /* previous- properties contain last allowed value of a changed input */
                vm.astroMenuValues.oldplace = vm.astroMenuValues.place;
                vm.astroMenuValues.oldlongitude = vm.astroMenuValues.longitude;
                vm.astroMenuValues.previouslongitude = vm.astroMenuValues.longitude;
                vm.astroMenuValues.oldlatitude = vm.astroMenuValues.latitude;
                vm.astroMenuValues.previouslatitude = vm.astroMenuValues.latitude;
            };

            vm.filterKeys = (event) => {
                if (event.charCode === 8 || event.charCode === 0) {
                    return null;
                }
                else if (
                    (event.charCode >= 48 && event.charCode <= 57)
                    || event.charCode === 45 // -
                ) {
                    return event.charCode;
                }
                else if (
                    event.charCode === 44 // ,
                    || event.charCode === 46 // .
                ) {
                    // only dot is allowed
                    return 46;
                }
                event.preventDefault();
                return null;
            };

            var DynHandler = {};

            /* Dynamic call */
            DynHandler.longitudeChanged = () => {
                vm.longitudeButtonsShow = true;
            };

            /* Dynamic call */
            DynHandler.latitudeChanged = () => {
                vm.latitudeButtonsShow = true;
            };

            vm.filterInput = (num, fieldName) => {
                /* If input is empty, clear variables. */
                if (num === '') {
                    vm.astroMenuValues[fieldName] = '';
                    vm.astroMenuValues['previous' + fieldName] = '';
                    DynHandler[fieldName + 'Changed']();
                    return;
                }

                /* Only minus sign is not valid number, do not save it. */
                if (num === '-') {
                    /* Wait for a next char. */
                    vm.astroMenuValues['previous' + fieldName] = '';
                    return;
                }

                /* Replace all commas with dots. */
                const find = ',';
                const re = new RegExp(find, 'g');
                num = num.replace(re, '.');

                /* If there is more than one dot next to each other, the value is not valid
                   -> remove one dot. */
                if (num.length > 1 && num.slice(-2) === '..') {
                    vm.astroMenuValues[fieldName] = num.slice(0, -1);
                    return;
                }
                /* Count all dots in the input. */
                else if (num.length > 1 && num.split('.').length > 2) {
                    /* More then one dot, revert back. */
                }
                /* The last character is a dot, do no validation, wait for a next char. */
                else if (num.length > 0 && num.slice(-1) === '.') {
                    vm.astroMenuValues[fieldName] = num;
                    return;
                }

                /* Test if an input is really a number in the known format */
                if (/^-?\d+(.?\d+)?$/.test(num)) {
                    vm.astroMenuValues['previous' + fieldName] = vm.astroMenuValues[fieldName];
                    if (num === +num) {
                        /* Valid input. A number, remember the value. */
                        vm.astroMenuValues[fieldName] = +num;
                    } else {
                        /* Happens for numbers with unimportant zeros at the end. For e.g. 12.70 and 12.7. Also valid. */
                        vm.astroMenuValues[fieldName] = num;
                    }
                }
                else {
                    /* Some unknown invalid input, better to revert to a correct value. */
                    vm.astroMenuValues[fieldName]  = +vm.astroMenuValues['previous' + fieldName] || '';
                }
                DynHandler[fieldName + 'Changed']();
            };

            /* Neccessary to clean autocomplete field. */
            vm.placeOnBlur = () => {
                if (vm.astroMenuValues.place === '') {
                    $timeout(function() {
                        vm.astroMenuValues.place = '';
                    }, 10);
                }
            };

            vm.placeChanged = () => {
                vm.positionButtonsShow = true;
            };

            vm.positionWriteValueByButton = () => {
                const api = new API();
                let writeValuesParams = {
                    'DatapointValues': [{
                        '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.String, mscorlib]], BMS.Shared',
                        'DeviceId': xCenterConfig.var.guid_Empty,
                        'DatapointConfigId': xCenterConfig.datapointsDateTime.Place,
                        'Value': vm.astroMenuValues.place
                    }]
                };
                api.Datapoint.WriteValues(writeValuesParams);

                vm.positionButtonsShow = false;
            };

            vm.positionResetValueByButton = () => {
                vm.positionButtonsShow = false;
                vm.longitudeButtonsShow = false;
                vm.latitudeButtonsShow = false;
                vm.astroMenuValues.place = vm.astroMenuValues.oldplace;
                vm.longitudeResetValueByButton();
                vm.latitudeResetValueByButton();
            };


            function reloadSunsetSunriseTimes() {
                const dataPoints = [{
                    'DeviceId': xCenterConfig.var.guid_Empty,
                    'DatapointConfigId': xCenterConfig.datapointsDateTime.Sunrise
                }, {
                    'DeviceId': xCenterConfig.var.guid_Empty,
                    'DatapointConfigId': xCenterConfig.datapointsDateTime.Sunset
                }];

                let readValuesParams = { "DatapointValues": dataPoints };
                var api = new API();
                api.Datapoint.ReadValues(readValuesParams).$promise
                .then(function (resp) {
                    vm.astroMenuValues.sunrise = moment(resp[0].Value);
                    vm.astroMenuValues.sunset = moment(resp[1].Value);
                }, function () {
                    $log.error('Error: Cannot call ReadValues!');
                });
            }

            vm.longitudeWriteValueByButton = () => {
                var api = new API();
                var writeValuesParams = {
                    'DatapointValues': [{
                        '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared',
                        'DeviceId': xCenterConfig.var.guid_Empty,
                        'DatapointConfigId': xCenterConfig.datapointsDateTime.Longitude,
                        'Value': vm.astroMenuValues.longitude
                    }]
                };
                api.Datapoint.WriteValues(writeValuesParams).$promise
                .then(function() {
                    reloadSunsetSunriseTimes();
                    vm.astroMenuValues.oldlongitude = vm.astroMenuValues.longitude;
                });

                vm.longitudeButtonsShow = false;
            };

            vm.longitudeResetValueByButton = () => {
                vm.longitudeButtonsShow = false;
                vm.astroMenuValues.longitude = vm.astroMenuValues.oldlongitude;
            };

            vm.latitudeWriteValueByButton = () => {
                var api = new API();
                var writeValuesParams = {
                    'DatapointValues': [{
                        '$type': 'BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared',
                        'DeviceId': xCenterConfig.var.guid_Empty,
                        'DatapointConfigId': xCenterConfig.datapointsDateTime.Latitude,
                        'Value': vm.astroMenuValues.latitude
                    }]
                };
                api.Datapoint.WriteValues(writeValuesParams).$promise
                .then(function() {
                    reloadSunsetSunriseTimes();
                    vm.astroMenuValues.oldlatitude = vm.astroMenuValues.latitude;
                });

                vm.latitudeButtonsShow = false;
            };

            vm.latitudeResetValueByButton = () => {
                vm.latitudeButtonsShow = false;
                vm.astroMenuValues.latitude = vm.astroMenuValues.oldlatitude;
            };

            $scope.$watch('vm.astroMenuValues.placeId', function () {
                if (!vm.useGoogleInput) {
                    vm.firstLoad = false;
                    return;
                }

                if (vm.firstLoad) {
                    googleMapsLoader.load().then(
                        function(message) {
                            vm.firstLoad = false;
                            console.log(message);
                        }
                    );
                    return;
                }

                DynHandler.latitudeChanged();
                DynHandler.longitudeChanged();
            });


        }
})();
